<template>
    <va-edit-layout>
        <RefundEventShipmentFee-form
            :id="id"
            :title="title"
            :item="item"
        ></RefundEventShipmentFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
